import { createAction } from '@reduxjs/toolkit';
export const SET_MULTIPLE_QUOTES = 'SET_MULTIPLE_QUOTES';
export const setMultipleQuotesAction = createAction<any>(SET_MULTIPLE_QUOTES);
export const UPDATE_MULTIPLE_QUOTES = 'UPDATE_MULTIPLE_QUOTES';
export const updateMultipleQuotesAction = createAction<any>(UPDATE_MULTIPLE_QUOTES);
